/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Room amenities
 * @export
 * @interface TravelineAmenityDto
 */
export interface TravelineAmenityDto {
    /**
     * Amenity code
     * @type {string}
     * @memberof TravelineAmenityDto
     */
    code: string;
}

/**
 * Check if a given object implements the TravelineAmenityDto interface.
 */
export function instanceOfTravelineAmenityDto(value: object): value is TravelineAmenityDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function TravelineAmenityDtoFromJSON(json: any): TravelineAmenityDto {
    return TravelineAmenityDtoFromJSONTyped(json, false);
}

export function TravelineAmenityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineAmenityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

  export function TravelineAmenityDtoToJSON(json: any): TravelineAmenityDto {
      return TravelineAmenityDtoToJSONTyped(json, false);
  }

  export function TravelineAmenityDtoToJSONTyped(value?: TravelineAmenityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
    };
}

